module.exports = __webpack_public_path__ + "img/pro_two_2.55e32a0a.jpg";